import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "limitWarning"]

  connect() {
    this.files = []
  }

  updateFilePreview() {
    const newFiles = Array.from(this.inputTarget.files)
    const MAX_FILE_SIZE_MB = 50
    
    // Check size
    for (const file of newFiles) {
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        this.limitWarningTarget.classList.remove("hidden")
        this.limitWarningTarget.textContent = `File "${file.name}" exceeds ${MAX_FILE_SIZE_MB}MB. Please choose a smaller file.`
        this.inputTarget.value = ""
        return
      }
    }
  
    const combined = [...this.files, ...newFiles]
    if (combined.length > 5) {
      this.limitWarningTarget.classList.remove("hidden")
      this.limitWarningTarget.textContent = "Maximum of 5 files allowed."
      this.inputTarget.value = ""
      return
    }
  
    this.limitWarningTarget.classList.add("hidden")
    this.limitWarningTarget.textContent = ""
    this.files = combined
  
    const dataTransfer = new DataTransfer()
    this.files.forEach(file => dataTransfer.items.add(file))
    this.inputTarget.files = dataTransfer.files
  
    this.renderPreview()
  }

  removeFile(event) {
    const name = event.currentTarget.dataset.filename
    this.files = this.files.filter(file => file.name !== name)

    const dataTransfer = new DataTransfer()
    this.files.forEach(file => dataTransfer.items.add(file))
    this.inputTarget.files = dataTransfer.files

    this.limitWarningTarget.classList.add("hidden")
    this.renderPreview()
  }

  renderPreview() {
    this.previewTarget.innerHTML = ""

    if (this.files.length === 0) {
      this.previewTarget.innerHTML = "<p class='text-sm text-gray-400'>No files selected</p>"
      return
    }

    this.files.forEach(file => {
      const container = document.createElement("div")
      container.className = "flex items-center justify-between space-x-4"

      const left = document.createElement("div")
      left.className = "flex items-center space-x-3"

      if (file.type.startsWith("image/")) {
        const img = document.createElement("img")
        img.className = "w-12 h-12 object-cover rounded border border-gray-300"
        const reader = new FileReader()
        reader.onload = e => img.src = e.target.result
        reader.readAsDataURL(file)
        left.appendChild(img)
      } else {
        const icon = document.createElement("div")
        icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" class="w-10 h-10 text-yellow-400"><path d="M19.5 8.25V6.621a.75.75 0 00-.22-.53l-4.621-4.62a.75.75 0 00-.53-.221H6.75A2.25 2.25 0 004.5 3.5v17.25A2.25 2.25 0 006.75 23h10.5A2.25 2.25 0 0019.5 20.75V9a.75.75 0 00-.75-.75h-.75zM14.25 3.75l3.5 3.5h-3.5v-3.5z"/></svg>`
        left.appendChild(icon)
      }

      const filename = document.createElement("p")
      filename.textContent = file.name
      filename.className = "text-sm text-gray-400 truncate max-w-xs"
      left.appendChild(filename)

      const removeBtn = document.createElement("button")
      removeBtn.type = "button"
      removeBtn.textContent = "Remove"
      removeBtn.dataset.action = "file-upload#removeFile"
      removeBtn.dataset.filename = file.name
      removeBtn.className = "text-sm text-red-400 hover:text-red-300"

      container.appendChild(left)
      container.appendChild(removeBtn)

      this.previewTarget.appendChild(container)
    })
  }
}
